import { render } from "./SpotifyPlaylists.vue?vue&type=template&id=a3482daa&scoped=true"
import script from "./SpotifyPlaylists.vue?vue&type=script&lang=js"
export * from "./SpotifyPlaylists.vue?vue&type=script&lang=js"

import "./SpotifyPlaylists.vue?vue&type=style&index=0&id=a3482daa&scoped=true&lang=css"

import exportComponent from "/Users/macbook/Mubasher/Mubasher/Projects/Live/bling-rock/Project-Live/soundcode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3482daa"]])

export default __exports__